import { Strings } from './Strings';

/**
 * 객체 관련 유틸
 */
export class Objects {
  /**
   * 전달받은 객체를 복사 후 반환
   * @param original
   */
  static copy(original): any {
    return JSON.parse(JSON.stringify(original));
  }

  static clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
  }

  /**
   * 전달받은 객체들을 병합대상 객체에 병합 후 반환
   * @param target
   * @param args
   */
  static merge(target, args): any {
    return Object.assign(target, args);
  }

  static safeGetValue(obj: any, propertyKey: string, defaultValue?: any): any {
    if (obj == undefined || obj == null)
      return defaultValue != null ? defaultValue : null;

    if (Strings.isBlank(propertyKey))
      return defaultValue != null ? defaultValue : null;

    const properties: string[] = propertyKey.split('.');

    let result: any = null;

    for (let i = 0; i < properties.length; i++) {
      const key = properties[i];
      const checkObj = result ? result : obj;

      if (!checkObj.hasOwnProperty(key))
        break;

      result = checkObj[key];
    }

    if (result != null)
      return result;
    else
      return defaultValue != null ? defaultValue : null;
  }

  static isEmpty(obj: any): boolean {

    if (!obj) return true;

    for (var p in Object.keys(obj))
      return false;

    return true;
  }

  static isNull(obj: any, key: string): boolean {

    if (obj == null) return true;

    if (!obj.hasOwnProperty(key)) return true;

    if (obj[key] == null) return true;

    return false;
  }

  static isNotNull(obj: any, key: string): boolean {
    return !this.isNull(obj, key);
  }

  static parseBoolean(value: any): boolean {
    if (value == null || value == undefined)
      return false;
    else if (value instanceof String)
      return Strings.parserBoolean(value.toString());
    else
      return JSON.parse(value);
  }
}
